import BaseService from '../baseService';
import config from '../../config'
import { CreateUpdateRequest, ChangePasswordRequest } from './contracts';

export default class extends BaseService {
    constructor() {
        super('account', config.AUTH_SERVICE_URL);
    }

    /**
     * Gets user by id(if null = get self info)
     * @param userId User guid
     */
    get = (userId?: string) => this.httpGetRequest(userId || '');

    /**
     * Gets list of users
     * @param filter JSON { userNames: string[], roles: string[] }
     */
    list = (filter?: { userNames: string[], roles: string[] }) => this.httpPostRequest('list', filter || {});

    /**
     * Creates user
     * @param request JSON { email: string, userName: string, password: string, userRole: string }
     */
    create = (request: CreateUpdateRequest) => this.httpPostRequest('', request);

    /**
     * Updates user
     * @param request JSON { email: string, userName: string, password: string }
     */
    update = (request: CreateUpdateRequest) => this.httpPutRequest('', request);

    /**
     * Deletes user
     * @param userId User guid
     */
    delete = (userId: string) => this.httpDeleteRequest(userId);

    /**
     * Resets user password
     * @param request JSON { password: string, currentPassword: string, userId: guid}
     */
    resetPassword = (request: ChangePasswordRequest) => this.httpPostRequest('resetPassword', request);

    /**
     * Resets all users passwords
     * @param request JSON { password: string }
     */
    resetPasswords = (request: { password: string }) => this.httpPostRequest('resetPasswords', request);
}
